import { render, staticRenderFns } from "./errorAPP.vue?vue&type=template&id=65b45a45"
import script from "./errorAPP.vue?vue&type=script&lang=js"
export * from "./errorAPP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports